import React, { useRef, useState } from "react"
import { App } from "antd"
import { useOutletContext } from "react-router-dom"

import { W1 } from "@components/constants"
import { Page } from "@components/Page"
import { useAppContext } from "@components/AppContext"
import { PropertyModal, PropertiesTable,  } from "@modules/backstage/properties"

import PropertyUpdateModal from "../PropertyUpdateModal"
import confirmPropertyDelete from "./helpers/confirmPropertyDelete"
import ProjectPropertyCreateModal from "../ProjectPropertyCreateModal"

const LABEL_TITLE = "Properties"
const LABEL_DELETE_MESSAGE = "Property $ is deleted"


const PropertiesPage = () => {
  const table = useRef({})
  const createModal = useRef({})
  const updateModal = useRef({})

  const { modal } = App.useApp()
  const { removeProjectProperty } = useOutletContext()
  const { request, showSuccessMessage } = useAppContext()

  const [ property, setProperty ] = useState(null)

  const openCreateModal = () =>
    createModal.current.openWithProperties()

  const openUpdateModal = id => {
    const { projectId } = table.current.getItem(id)
    updateModal.current.open(id, projectId)
  }

  const openDeleteConfirm = propertyId => {
    const { projectId, name } = table.current.getItem(propertyId)

    confirmPropertyDelete(modal, request, propertyId, () => {
      removeProjectProperty(projectId, propertyId)
      table.current.deleteItem(propertyId)
      showSuccessMessage(LABEL_DELETE_MESSAGE.replace("$", `"${name}"`))
    })
  }

  const openPropertyModal = id =>
    setProperty(table.current.getItem(id))

  const onSearch = value =>
    table.current.search(value)

  const style = {
    padding: W1,
    paddingBottom: 0,
  }

  return (
    <Page
      style={style}
      title={LABEL_TITLE}
      onSearch={onSearch}
    >
      <PropertiesTable
        table={table}
        onOpen={openPropertyModal}
        onCreate={openCreateModal}
        onUpdate={openUpdateModal}
        onDelete={openDeleteConfirm}
      />

      <ProjectPropertyCreateModal
        table={table}
        modal={createModal}
      />

      <PropertyUpdateModal
        table={table}
        updateModal={updateModal}
      />

      <PropertyModal
        property={property}
        onCancel={() => setProperty(null)}
      />
    </Page>
  )
}

export default PropertiesPage
